import React, { useState, useEffect } from 'react';

import { 
    FormInput_text, FormGroupRadio, Datepicker, 
    TextareaModal, Toaster, Dropdown 
} from "components";

import { convertArrayToDropdownArrayFormat, func_validation, getObjectPropertyValue_stringTrimNotEmpty, getObjectPropertyValue_validNumber, isArrayNotEmpty, isBooleanFalseNotNullUndefined, isDateValid, isFunction, isNumberValid, isStringEqual_caseInsensitive, isStringTrimEmpty, isStringTrimNotEmpty } from "functions";
import { FormInput_textarea } from 'components/form/formInput/FormInput_textarea';
import moment, { isDate } from 'moment';



export function useMiscellaneousInputs(props) {
    const { 
        isEditing,
        billingSetup,
        isFormSubmissionAttempted, isDefaultProduct,
        referenceValue, setReferenceValue,
        referenceValue_init,
        referenceValuePlaceholder_init, referenceValuePlaceholder, setReferenceValuePlaceholder,
        companyDetails, isTypingAccountCode,
        chargeDetails,
        isDraft,
        billingSetupRemarks = null,

        // Functions
        getRemarks
    } = props;

    // Validate initial state values

    let currentDate_toString = moment().format("YYYY-MM-DD");
    let lastBilledDatetime_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "LastBilledDateTime", currentDate_toString);
    let nextBilledDatetime_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "NextBilledDateTime", currentDate_toString);
    let lastBilledDateDay_init = getObjectPropertyValue_validNumber(billingSetup, "LastBilledDateDay");
    let firstDayOfTodaysMonth = moment().date(1);
    let cutOffDate_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "CutOffDate", firstDayOfTodaysMonth.format("YYYY-MM-DD"));
    if (isDateValid(cutOffDate_init)) cutOffDate_init = moment(cutOffDate_init).date(1).format("YYYY-MMM-DD");
    let salesOrderNumberRef_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "SalesOrderNumberRef", "");


    // States
    const [lastBilledDatetime, setLastBilledDatetime] = useState(lastBilledDatetime_init);
    const [nextBilledDatetime, setNextBilledDatetime] = useState(nextBilledDatetime_init);
    const [lastBilledDateDay, setLastBilledDateDay] = useState(lastBilledDateDay_init);
    const [cutOffDate, setCutOffDate] = useState(cutOffDate_init);
    const [salesOrderNumberRef, setSalesOrderNumberRef] = useState(salesOrderNumberRef_init);
    const [isReferenceValueModalVisible, setIsReferenceValueModalVisible] = useState(false);
    const [remarks, setRemarks] = useState(billingSetupRemarks);
    const [isComponentMounted, setIsComponentMounted] = useState(false);
    useEffect(() => { setIsComponentMounted(true); }, []);

    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            lastBilledDatetime === lastBilledDatetime_init &&
            nextBilledDatetime === nextBilledDatetime_init &&
            lastBilledDateDay === lastBilledDateDay_init &&
            (isStringTrimNotEmpty(cutOffDate) && cutOffDate.length >= 7 &&
                isStringTrimNotEmpty(cutOffDate_init) && cutOffDate_init.length >= 7 &&
                cutOffDate.substring(0,7) === cutOffDate_init.substring(0,7)) &&
            referenceValue === referenceValue_init &&
            remarks === billingSetupRemarks
        );

        let isChangedFromEmpty = (
            lastBilledDatetime || nextBilledDatetime || cutOffDate || referenceValue || remarks
        );

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);    
    }, [
        lastBilledDatetime, nextBilledDatetime, lastBilledDateDay,
        cutOffDate, 
        referenceValue, isReferenceValueModalVisible, referenceValuePlaceholder,
        remarks
    ]);
    
    function referenceValue_onConfirm(value) {
        if (isStringTrimNotEmpty(value)) {
            let valueArray = value.trim().split("\n");
            let totalValues = 0;

            if (isArrayNotEmpty(valueArray)) {
                let arraySize = valueArray.length;
                for (let i = 0; i < arraySize; i++) {
                    let referenceValue = valueArray[i];

                    if (isStringTrimNotEmpty(referenceValue))
                        totalValues++;
                }
            }
    
            setReferenceValuePlaceholder(totalValues + " value(s)");
            if (isFunction(props.setReferenceValue)) props.setReferenceValue(value);
        }
        else {
            setReferenceValuePlaceholder("");
            if (isFunction(props.setReferenceValue)) props.setReferenceValue("");
        }
    }

    function handleReferenceValueInputClick() {
        if (chargeDetails?.ChargeMethod === "System") {
            Toaster({
                type: "info",
                msg: "Charge Method cannot be 'System'"
            });
        }
        else {
            isDefaultProduct? 
                Toaster({
                    type: "info",
                    msg: "Please set Default Product as false."
                })
            :setIsReferenceValueModalVisible(true); 
        }
    }
    function referenceValue_updateStates() {
        if (!isDefaultProduct && isComponentMounted &&
            isStringTrimNotEmpty(referenceValue) &&
            !(chargeDetails?.ChargeMethod === "System")) {
                
            setReferenceValuePlaceholder("");
            setReferenceValue("");
        }
    }
    useEffect(() => {
        referenceValue_updateStates();
    }, [isDefaultProduct]);

    // List of number from 1 - 31 inclusive
    let lastBilledDateDay_options = [];
    for (let i = 1; i < 32; i++) {
        lastBilledDateDay_options.push(i);
    }

    // Get Remarks
    useEffect(() => {
        let accountCode = companyDetails?.AccountCode;

        if (!isTypingAccountCode && accountCode && getRemarks)
            getRemarks(accountCode);
    }, [companyDetails?.AccountCode, isTypingAccountCode]);
    useEffect(() => {
        if (billingSetupRemarks) setRemarks(billingSetupRemarks);
    }, [billingSetupRemarks])

    // Display
    let display = (
        <>
            <div className="recursiveBillingSetupAccountUpdate-miscellaneous d-flex flex-wrap">
                {/* Last Billed Date */}
                <Datepicker
                    className={"recursiveBillingSetupAccountUpdate-lastBilledDate"}
                    inputClassName={"recursiveBillingSetupAccountUpdate-lastBilledDate-input"}
                    
                    label={"Last Billed Date"}
                    defaultDate={lastBilledDatetime}
                    handleOnChange={setLastBilledDatetime}

                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    errorMsg={"Required"}

                    isConversionRequired_ISO8601 isInputRequired
                />

                {/* Last Billed Date Day */}
                <Dropdown
                    className={"recursiveBillingSetupAccountUpdate-lastBilledDateDay"}
                    label={"Last Billed Date Day"}
                    isInputRequired

                    selectedValueClassName={"recursiveBillingSetupAccountUpdate-lastBilledDateDay-input"}

                    options={convertArrayToDropdownArrayFormat(lastBilledDateDay_options)}
                    selectedValue_default={lastBilledDateDay}
                    onChange={setLastBilledDateDay}

                    errorMsg={"Required"}
                    isFormSubmissionAttempted={isFormSubmissionAttempted}

                    minInputDigit={1}
                    minInputDigit_invalidMsg={"Last Billed Date Day must be between 1 and 31 inclusive"}
                    isInputDigitOnly

                    isSearchable
                    isInputValueTrim_onChange isOptionPosition_up
                />

                {/* Next Billed Date */}
                <Datepicker
                    className={"recursiveBillingSetupAccountUpdate-nextBilledDate"}
                    inputClassName={"recursiveBillingSetupAccountUpdate-nextBilledDate-input"}

                    label={"Next Billed Date"}
                    defaultDate={nextBilledDatetime}
                    handleOnChange={setNextBilledDatetime}

                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    errorMsg={"Required"}

                    isConversionRequired_ISO8601 isInputRequired
                /> 

                {/* Cut Off Date */}
                <Datepicker
                    className={"recursiveBillingSetupAccountUpdate-cutOffDate"}
                    inputClassName={"recursiveBillingSetupAccountUpdate-cutOffDate-input"}
                    
                    label={"Cut Off Date"}
                    defaultDate={cutOffDate}
                    dateFormat={"MM/yyyy"}
                    handleOnChange={setCutOffDate}

                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    errorMsg={"Required"}

                    isConversionRequired_ISO8601 isMonthYear
                />

                {/* Reference Value */}
                <FormInput_text
                    className={"recursiveBillingSetupAccountUpdate-referenceValues"}
                    customInputClassName={"recursiveBillingSetupAccountUpdate-referenceValues-input"}
                    inputValue={referenceValuePlaceholder}

                    inputLabel={"Reference Value(s)"}
                    isInputOptional

                    handleInputClickExtend={handleReferenceValueInputClick}
                    isInputClickHandlingRequired

                    customErrorMsg={"Required"}
                    customErrorValidation={
                        isFormSubmissionAttempted && 
                        (isBooleanFalseNotNullUndefined(isDefaultProduct) && 
                        isStringTrimEmpty(referenceValue)
                    )}

                    isMarginBtmOptional
                    isInputDisabled={isStringEqual_caseInsensitive(chargeDetails?.ChargeMethod, "System") || isDefaultProduct}
                    inputCustomOptions={{ readOnly: true }}
                />

                {/* Sales Order Number Ref */}
                <FormInput_text
                    inputLabel={"Sales Order Number Ref"}
                    isInputOptional
                    className={"recursiveBillingSetupAccountUpdate-salesOrderNumberRef"}
                    inputValue={salesOrderNumberRef}
                    isMarginBtmOptional
                    isInputDisabled={true}
                />
                <TextareaModal
                    title={"Reference Value(s)"}

                    inputValue={referenceValue}
                    placeholder={"Enter one reference value per line"}
                    confirmButtonText={"Save"}

                    isModalVisible={isReferenceValueModalVisible}
                    updateParentState={setIsReferenceValueModalVisible}

                    handleOnConfirm={(value) => { 
                        referenceValue_onConfirm(value);
                        setIsReferenceValueModalVisible(false);
                    }}
                />
            </div>

            <div className={"recursiveBillingSetupAccountUpdate-notes"}>
                <FormInput_textarea
                    inputLabel={"Customer Note"}
                    isInputOptional

                    className={"notes__remarks"}
                    customInputClassName={"remarks__input"}
                    inputValue={remarks}

                    propagateValueChange={(statName, value) => {
                        setRemarks(value);
                    }}

                    isMarginBtmOptional isErrorMsgOptional
                />
            </div>
        </>
    );

    let isEveryInputValid = (
        isDateValid(lastBilledDatetime) &&
        isDateValid(nextBilledDatetime) &&
        // isStringTrimNotEmpty(cutOffDate) &&
        isNumberValid(lastBilledDateDay)
    );

    let miscellaneousDetails = {
        LastBilledDateTime: lastBilledDatetime,
        LastBilledDateDay: lastBilledDateDay,
        NextBilledDateTime: nextBilledDatetime,
        CutOffDate: cutOffDate,
        Remarks: remarks,
        SalesOrderNumberRef: salesOrderNumberRef,
    }

    return {
        miscellaneousDetails, referenceValue,

        isEveryInputValid,
        isAnyInputChanged,
        
        display
    }
}